import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from './Header';
import './Dashboard.css';

function Dashboard({ user, onLogout }) {
  const [todayTasks, setTodayTasks] = useState([]);
  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    inProgress: 0,
    completed: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const today = new Date().toISOString().split('T')[0];
      
      // Get today's tasks
      const tasksResponse = await axios.get('/tasks', {
        params: { date: today }
      });
      
      setTodayTasks(tasksResponse.data.tasks);

      // Get all tasks for stats
      const allTasksResponse = await axios.get('/tasks');
      const tasks = allTasksResponse.data.tasks;

      setStats({
        total: tasks.length,
        pending: tasks.filter(t => t.status === 'pending').length,
        inProgress: tasks.filter(t => t.status === 'in_progress').length,
        completed: tasks.filter(t => t.status === 'completed').length
      });

      setLoading(false);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      setLoading(false);
    }
  };

  const getPriorityClass = (priority) => {
    return `priority-${priority}`;
  };

  const getPriorityText = (priority) => {
    const map = { high: 'Υψηλή', medium: 'Μεσαία', low: 'Χαμηλή' };
    return map[priority] || priority;
  };

  if (loading) {
    return (
      <div>
        <Header user={user} onLogout={onLogout} />
        <div className="dashboard-container">
          <div className="loading">Φόρτωση...</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header user={user} onLogout={onLogout} />
      
      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1>Καλωσήρθες, {user.full_name}! 👋</h1>
          <p className="date">{new Date().toLocaleDateString('el-GR', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
          })}</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <h3>Σύνολο</h3>
            <p className="stat-number">{stats.total}</p>
          </div>
          <div className="stat-card pending">
            <h3>Εκκρεμούν</h3>
            <p className="stat-number">{stats.pending}</p>
          </div>
          <div className="stat-card in-progress">
            <h3>Σε Εξέλιξη</h3>
            <p className="stat-number">{stats.inProgress}</p>
          </div>
          <div className="stat-card completed">
            <h3>Ολοκληρωμένες</h3>
            <p className="stat-number">{stats.completed}</p>
          </div>
        </div>

        <div className="today-section">
          <div className="section-header">
            <h2>Οι Υποχρεώσεις σου για Σήμερα</h2>
            <Link to="/tasks/new" className="btn-primary">
              + Νέα Υποχρέωση
            </Link>
          </div>

          {todayTasks.length === 0 ? (
            <div className="empty-state">
              <p>🎉 Δεν έχεις υποχρεώσεις για σήμερα!</p>
              <Link to="/tasks" className="btn-secondary">
                Δες Όλες τις Υποχρεώσεις
              </Link>
            </div>
          ) : (
            <div className="tasks-list">
              {todayTasks.map(task => (
                <Link to={`/tasks/${task.id}`} key={task.id} className="task-card">
                  <div className="task-header">
                    <h3>{task.title}</h3>
                    <span className={`priority-badge ${getPriorityClass(task.priority)}`}>
                      {getPriorityText(task.priority)}
                    </span>
                  </div>
                  {task.description && (
                    <p className="task-description">{task.description}</p>
                  )}
                  <div className="task-footer">
                    <span className="task-status">{task.status === 'pending' ? 'Εκκρεμεί' : task.status === 'in_progress' ? 'Σε Εξέλιξη' : 'Ολοκληρώθηκε'}</span>
                    {task.assigned_users && task.assigned_users.length > 1 && (
                      <span className="task-users">
                        👥 {task.assigned_users.length} άτομα
                      </span>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>

        <div className="quick-actions">
          <Link to="/tasks" className="action-link">
            📋 Όλες οι Υποχρεώσεις
          </Link>
          <Link to="/tasks?status=pending" className="action-link">
            ⏳ Εκκρεμείς Υποχρεώσεις
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
